import { Button } from "@/components/ui/Button";

export function TableSortResetBar({
  visible,
  onReset,
  className,
}: {
  visible: boolean;
  onReset: () => void;
  className?: string;
}) {
  if (!visible) return null;

  return (
    <div className={className ?? "mb-2 flex justify-end"}>
      <Button type="button" variant="secondary" size="sm" onClick={onReset}>
        Sortierung zurücksetzen
      </Button>
    </div>
  );
}
